import initList from '~/packages_and_registries/infrastructure_registry/list_app_bundle';

initList();
